import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=23e9ecc5&scoped=true"
import script from "./sms.vue?vue&type=script&lang=js"
export * from "./sms.vue?vue&type=script&lang=js"
import style0 from "./sms.vue?vue&type=style&index=0&id=23e9ecc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9ecc5",
  null
  
)

export default component.exports